/**
 * Shared language constants for portal i18n.
 *
 * These locale codes match the assessment translation system
 * (src/components/Assessment/constants/translations.ts) so the
 * portal and assessment stay aligned.
 */

export type SupportedLocale =
    | 'en-US'
    | 'en-SG'
    | 'en-GB'
    | 'en-AU'
    | 'es-MX'
    | 'fr-CA'
    | 'zh-CN'
    | 'zh-SG'
    | 'pt-BR'
    | 'ko-KR'
    | 'vi-VN'
    | 'en-IN'
    | 'hi-IN'
    | 'te-IN'
    | 'ta-IN'
    | 'kn-IN'
    | 'ml-IN';

export const DEFAULT_LOCALE: SupportedLocale = 'en-US';

export const SUPPORTED_LOCALES: SupportedLocale[] = [
    'en-US',
    'en-SG',
    'en-GB',
    'en-AU',
    'es-MX',
    'fr-CA',
    'zh-CN',
    'zh-SG',
    'pt-BR',
    'ko-KR',
    'vi-VN',
    'en-IN',
    'hi-IN',
    'te-IN',
    'ta-IN',
    'kn-IN',
    'ml-IN',
];

/** Human-readable labels for the language picker UI. */
export const LANGUAGE_NAMES: Record<SupportedLocale, string> = {
    'en-US': 'English (US)',
    'en-SG': 'English (Singapore)',
    'en-GB': 'English (UK)',
    'en-AU': 'English (Australia)',
    'es-MX': 'Español (México)',
    'fr-CA': 'Français (Canada)',
    'zh-CN': '中文（中国）',
    'zh-SG': '中文（新加坡）',
    'pt-BR': 'Português (Brasil)',
    'ko-KR': '한국어 (대한민국)',
    'vi-VN': 'Tiếng Việt (Việt Nam)',
    'en-IN': 'English (India)',
    'hi-IN': 'हिन्दी (भारत)',
    'te-IN': 'తెలుగు (భారతదేశం)',
    'ta-IN': 'தமிழ் (இந்தியா)',
    'kn-IN': 'ಕನ್ನಡ (ಭಾರತ)',
    'ml-IN': 'മലയാളം (ഇന്ത്യ)',
};
